export default function AuthTextBox({
  rootClass,
  label,
  optional,
  subLabel,
  id,
  error,
  errorMessage,
  extraInputClass,
  suffix,
  ...props
}) {
  const labelClass = error
    ? "block text-sm font-medium text-red-700 dark:text-red-500"
    : "block text-sm font-medium text-gray-900";

  const inputClass = error
    ? "bg-red-50 border border-red-500 text-red-900 placeholder-red-700 text-sm rounded-lg focus:ring-red-500 focus:border-red-500 block w-full p-2.5 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500"
    : "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-brand-lime focus:border-brand-lime block w-full p-2.5 dark:focus:ring-brand-lime dark:focus:border-brand-lime";

  return (
    <div className={rootClass}>
      <div>
        {label && (
          <label htmlFor={id} className={labelClass}>
            {label}
            {optional && (
              <span className="pl-2 text-gray-400 italic">- Optional</span>
            )}
          </label>
        )}
        {subLabel && (
          <span className="text-sm text-gray-500">
            {subLabel}
          </span>
        )}

        <div className="pt-2">
          <div className="relative flex items-center mb-2">
            <input
              id={id}
              className={`${inputClass} ${extraInputClass || ""}`}
              autoComplete="off"
              {...props}
            />
            {suffix && (
              <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center justify-center cursor-pointer">
                {suffix}
              </div>
            )}
          </div>

          {error && (
            <p className="mt-2 text-sm text-red-600 dark:text-red-500">
              <span className="font-medium">
                {errorMessage || "Please fill out this field"}
              </span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
